/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

import {from, Observable} from 'rxjs';

import {Image} from './images.interfaces';

import * as Croppie from 'croppie';
import {Files} from '../utils/files';
import {isPresent} from '../utils/lang';

/**
 * Component that let the user crop an image
 *
 * Usage :
 *
 * ```
 * <form>
 *   <gp-image-cropper [file]="photo"></gp-image-picker>
 *   (...)
 * </form>
 * ```
 */
@Component({
  selector: 'gp-image-cropper',
  template: `
    <div [attr.data-hidden]="!imageSource">
      <div class="preview" #preview></div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None
  // styleUrls: ['croppie/croppie.css']
})
export class ImageCropperComponent implements OnChanges {

  // Will hold the data URI source of our preview image
  public imageSource: string;

  @Input()
  private sizes: any = {width: 200, height: 200};

  @Input()
  private file: File;

  @Output()
  private update: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('preview', {static: true})
  private preview: ElementRef;

  // private dimensions: ImageDimensions;

  private fileReader: FileReader = new FileReader();

  private croppie: Croppie;

  constructor() {
    this.fileReader.onload = this.imageLoaded.bind(this);
  }

  public ngOnChanges(changes: {}): any {
    if (isPresent(this.file)) {
      this.preview.nativeElement.innerHTML = '';
      this.croppie = new Croppie(this.preview.nativeElement, {
        viewport: {width: 150, height: 150},
        boundary: {width: 200, height: 200},
        update: (data) => this.update.emit(data)
      });
      this.fileReader.readAsDataURL(this.file);
    }
  }

  public getResult(): Observable<Image> {
    return from(
      this.croppie.result({type: 'canvas', size: {width: this.sizes.width, height: this.sizes.height}}).then(value => {
        this.reset();
        return {
          dimensions: {
            width: this.sizes.width,
            height: this.sizes.height
          },
          file: Files.dataURItoBlob(value),
          mimeType: 'image/png',
          fileName: this.file.name
        };
      })
    );
  }

  public reset() {
    // this.dimensions = undefined;
    this.imageSource = undefined;

    this.croppie.destroy();
  }

  private imageLoaded(event: ProgressEvent) {
    this.imageSource = <string>(<FileReader>event.target).result;

    this.croppie.bind({
      url: this.imageSource
    });

    // const image = new Image(),
    //   mimeType = `image/${this.file.name.split('.').pop()}`;
    //
    // image.addEventListener('load', () => {
    //   this.dimensions = {
    //     width: image.width,
    //     height: image.height
    //   };
    // });
    // image.src = this.imageSource;
  }

}
